import { render } from "./FooterLink.vue?vue&type=template&id=45552a22&scoped=true"
import script from "./FooterLink.vue?vue&type=script&lang=js"
export * from "./FooterLink.vue?vue&type=script&lang=js"

import "./FooterLink.vue?vue&type=style&index=0&id=45552a22&lang=scss&scoped=true"

import exportComponent from "D:\\QYYY\\mall_pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45552a22"]])

export default __exports__